<template>
    <div>
        <NavbarStyleTwo />
        <PageTitle
            pageTitle="Funktionen"
            pageDesc="Was Benovium für Sie tun kann"
        />
        <AmazingFeatures />
        <FreeTrial />
        <FooterStyleOne />
    </div>
</template>

<script>
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import AmazingFeatures from '../HomeThree/AmazingFeatures'
import FreeTrial from '../Common/FreeTrial'
import FooterStyleOne from '../Layouts/FooterStyleOne'

export default {
    components: {
        NavbarStyleTwo,
        PageTitle,
        AmazingFeatures,
        FreeTrial,
        FooterStyleOne,
    }
};
</script>